<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      
      <vx-card title="">
        <div class="demo-alignment">
          
            
            <vs-button @click="siparisListesi()" color="success" type="filled">Çekilen Siparişleri Listele</vs-button>
            
            <vs-button @click="siparisKontrol()" color="dark" ref="loadableButton" id="button-with-loading-control" class="vs-con-loading__container"  type="filled">Sipariş Kontrol</vs-button>
            <vs-button @click="activePrompt = true" color="warning"  id="button-with-loading-partile" class="vs-con-loading__container" type="filled">Partile</vs-button>

            <vs-input type="text" placeholder="Sipariş No" vs-placeholder="Code" v-model="tekSiparisNo" class="" />
            <vs-button @click="tekSiparisCek()" color="red"  id="button-with-loading-s" class="vs-con-loading__container" type="filled">Tek Sipariş Çek</vs-button>
            <vs-progress :percent="progress"  v-model="progress"  color="primary"></vs-progress>
            
        </div>
      </vx-card>
      <vx-card title="">
        
      </vx-card>
    </div>


    <div class="vx-col lg:w-4/4 w-full relative">

  <vs-table :data="list" :hidden="validated">

    <template slot="thead">
      <vs-th  sort-key="stokkodu">Sipariş No</vs-th>
      <vs-th>Adı Soyadı</vs-th>
      <vs-th>Kargo No</vs-th>
      <vs-th>Tutar</vs-th>
      <vs-th>Parca Adedi</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

        <vs-td :data="data[indextr].orderNumber">
          {{ data[indextr].orderNumber }}
        </vs-td>
        <vs-td :data="data[indextr].invoiceFirstName">
          {{ data[indextr].invoiceFirstName }} {{ data[indextr].invoiceLastName }}
        </vs-td>
        <vs-td :data="data[indextr].cargoTrackingNumber">
          {{ data[indextr].cargoTrackingNumber }}
        </vs-td>

        <vs-td :data="data[indextr].grossAmount">
           {{ data[indextr].grossAmount }} 
        </vs-td>

        <vs-td :data="data[indextr].siparisAdetleri">
           {{ data[indextr].siparisAdetleri }} 
        </vs-td>
       
       
      </vs-tr>
      <vs-td colspan="4" style="text-align:right">Toplam : </vs-td>
      <vs-td>{{toplamParca}} Parça</vs-td>
      <vs-tr>

      </vs-tr>
    </template>

  </vs-table>
<vs-table :data="listEksik" :hidden="validated1">

    <template slot="thead">
      <vs-th  sort-key="stokkodu">Sipariş No</vs-th>
      <vs-th  sort-key="stokkodu">Parti No</vs-th>
      <vs-th>Adı Soyadı</vs-th>
      <vs-th>Ürün Kodu</vs-th>
      <vs-th>Ürün Adı</vs-th>
      <vs-th>Adet</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

        <vs-td :data="data[indextr].orderNumber">
          {{ data[indextr].orderNumber }}
        </vs-td>
        <vs-td :data="data[indextr].partiNo">
          {{ data[indextr].partiNo }}
        </vs-td>
        <vs-td :data="data[indextr].musteriAdi">
          {{ data[indextr].musteriAdi }}
        </vs-td>
        <vs-td :data="data[indextr].merchantSku">
          {{ data[indextr].merchantSku }}
        </vs-td>

        <vs-td :data="data[indextr].productName">
           {{ data[indextr].productName }} 
        </vs-td>

        <vs-td :data="data[indextr].quantity">
           {{ data[indextr].quantity }} 
        </vs-td>
       
       
      </vs-tr>
     
     
    </template>

  </vs-table>

<div class="con-pagination-table vs-table--pagination">
  <div class="vs-row" style="justify-content: space-between; display: flex; width: 100%;">
    <div class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6" style="justify-content: flex-start; display: flex; align-items: center; margin-left: 0%; width: 100%;">
      </div>
      <div class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6" style="justify-content: flex-end; display: flex; align-items: center; margin-left: 0%; width: 100%;">
        <div class="con-vs-pagination vs-pagination-primary">
          <nav class="vs-pagination--nav">
            <button class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev" @click="sayfaGeri();">
              <i class="vs-icon notranslate icon-scale material-icons null">chevron_left</i>
              </button>
              <ul class="vs-pagination--ul">
                
              </ul>
                <button class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" @click="sayfaIleri();">
                  <i class="vs-icon notranslate icon-scale material-icons null">chevron_right</i>
                  </button>
                  <!---->
                  </nav>
                  </div>
                  </div>
                  </div>
                  </div>

</div>

</div>
    


     
<vs-prompt title="Partileme İşlemleri" acceptText="İşlemi Başlat" cancelText="Vazgeç"
      @accept="partilemeyiBaslat"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Partileme Miktarı</span>
      <vs-input type="number" placeholder="Sayı Giriniz" vs-placeholder="Code" v-model="partiVal" class="mt-3 w-full" />
      </div>
    </vs-prompt>
          
           
    </div>


    
</template>



<script>
import state from '../../store/state'
import Store from '../../store/store'
export default {
  data () {
    return {
  list: [],
  listEksik:[],
  tekSiparisNo:'',
  progress:0,
  sayfaListe:0,
  toplamSayfa:0,
  activePrompt:false,
  partiVal:'',
  toplamParca:0,
  backgroundLoading:'danger',
  colorLoading:'#fff',
  siparisKaydetSayi:0,
  validated:true,
  validated1:true,
  siparisKontrolBasildimi:0,
  islemTipi:Store.state.islemTipi
    }
  },methods: {
   siparisCek(sayfasayisi) {
      var vs = this.$vs
     vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-yeni",
        scale: 0.45
      })


      var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Ticimax',siparisDurumu:0,listelenecekSayfa:sayfasayisi,token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.pazaryeriSiparisCek(args, function(err, result){
        if (result.pazaryeriSiparisCekResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.pazaryeriSiparisCekResult)
     // alert(vm.veriler.response)
    
      if (vm.veriler.response=='Ok') {
        if (parseInt(sayfasayisi)<parseInt(vm.veriler.totalPages)) {
          vm.veriler.page=parseInt(sayfasayisi)+1
          const percent=100/parseInt(vm.veriler.totalPages)
          vm.progress=percent*vm.veriler.page;
       //   alert(vm.veriler.page)
          vm.siparisCek(vm.veriler.page)
        } else {
          vs.loading.close("#button-with-loading-yeni > .con-vs-loading")
           vs.notify({
            title: 'Ticimax',
            text: "Siparişler Çekildi",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })
          vm.siparisKontrol()
        }
      } else {
        alert('Veriler Çekilemedi');
      }
      })
      })

   },
   tekSiparisCek() {
      var vs = this.$vs
    

      var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Ticimax',siparisDurumu:0,listelenecekSayfa:0,token:Store.state.tokenId,siparisNo:this.tekSiparisNo}
      soap.createClient(url, function(err, client){
      client.pazaryeriSiparisCekSiparisNo(args, function(err, result){
        if (result.pazaryeriSiparisCekSiparisNoResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.pazaryeriSiparisCekSiparisNoResult)
     // alert(vm.veriler.response)
    
      if (vm.veriler.response=='Ok') {
        
         
           vs.notify({
            title: 'Ticimax',
            text: "Siparişler Çekildi",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })
          vm.siparisKontrol()
       
      } else {
        alert('Veriler Çekilemedi');
      }
      })
      })

   },
   sayfaIleri() {
     this.sayfaListe=this.sayfaListe+1;
     if (this.sayfaListe>this.toplamSayfa) {
       this.sayfaListe=this.toplamSayfa;
     }
     this.siparisListesi();
   },
   sayfaGeri() {
     this.sayfaListe=this.sayfaListe-1;
      if (this.sayfaListe<0) {
        this.sayfaListe=0;
      }
     this.siparisListesi();
   },
   siparisListesi() {
     this.validated1=true
     this.validated=false
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Ticimax',token:Store.state.tokenId,sayfa:vm.sayfaListe}
      soap.createClient(url, function(err, client){
      client.siparisListele(args, function(err, result){
        if (result.siparisListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.siparisListeleResult)
      vm.toplamSayfa=vm.veriler[0]["toplamKayitSayisi"];
      vm.list=vm.veriler
      })
      })


   },
   kalanSiparisListesi() {
    this.validated1=false
     this.validated=true
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Ticimax',token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.kalanSiparisListesi(args, function(err, result){
        if (result.siparisListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.kalanSiparisListesiResult)
      vm.listEksik=vm.veriler
      })
      })


   },
   partilemeyiBaslat() {
      const vm = this
      var vs=this.$vs
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Ticimax',parti:this.partiVal,token:Store.state.tokenId}

      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-partile",
        scale: 0.45
      })


      soap.createClient(url, function(err, client){
      client.partile(args, function(err, result){
        if (result.partileResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

      vm.veriler=JSON.parse(result.partileResult)
        if (vm.veriler.response=='Ok') {
          vs.loading.close("#button-with-loading-partile > .con-vs-loading")
          vs.notify({
            title: 'Partileme',
            text: "Partileme İşlemi Başarılı",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })

        } else {
          vs.notify({
            title: 'Partileme',
            text: "Partilemede Hata Oluştu",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'error',
            position:'top-center'
          })
        }
      })
      })
     
   },
   siparisKaydet() {
     var vs = this.$vs
     if (this.siparisKontrolBasildimi==1) {
     vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })


     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {program: 'Ticimax',sayfa:this.siparisKaydetSayi,token:Store.state.tokenId,EMPLOYEEID:Store.state.plasiyer}
      soap.createClient(url, function(err, client){
      client.siparisKaydet(args, function(err, result){
        if (result.siparisKaydetResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.siparisKaydetResult)
      //console.log(vm.veriler)
      if (vm.veriler.response=='Ok') {
        vm.siparisKaydetSayi=parseInt(vm.siparisKaydetSayi)+500;
        alert(vm.siparisKaydetSayi)
        vm.siparisKaydet()
      }
      if (vm.veriler.response=='Bitti') {
         vs.loading.close("#button-with-loading > .con-vs-loading")
         vm.siparisKontrol()
      }
     
      })
      })
      
       } else {
         vs.notify({
            title: 'Sipariş Kayıt',
            text: "Siparişi Kaydetmeden Önce Sipariş Kontrol Butonuna Basınız",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
      }
   },
   siparisKontrol() {
     this.siparisKontrolBasildimi=1
    this.validated1=true
     this.validated=false
     const vm = this
var vs = this.$vs
     vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-control",
        scale: 0.45
      })

     const soap = require('soap')
      const url = state.sistemAddress
      const args = {program: 'Ticimax',token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.siparisKontrol(args, function(err, result){
        if (result.siparisKontrolResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.siparisKontrolResult)
      vm.list=vm.veriler
     
         vs.loading.close("#button-with-loading-control > .con-vs-loading")
       })
      })
   },
   
  },
  watch: {
    list: {
      handler: function () {
       
        //this.toplamParca=this.list.reduce((acc, item) => Number(acc) + (Number(item.siparisAdetleri)), 0)
        this.toplamParca=this.list.reduce((sum, item) => sum + item.siparisAdetleri, 0);
      },
      deep: true
    }
  }
  
}

</script>
<style lang="scss" scoped>
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
